class Logger {
  private readonly isProduction: boolean;

  constructor() {
    this.isProduction = !import.meta.env.DEV;
  }

  public log(...args: unknown[]): void {
    if (!this.isProduction) {
      // eslint-disable-next-line no-console
      console.log(...args);
    }
  }

  public warn(...args: unknown[]): void {
    if (!this.isProduction) {
      // eslint-disable-next-line no-console
      console.warn(...args);
    }
  }

  public error(...args: unknown[]): void {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
}

const logger = new Logger();

export default logger;
